export const fixValues = (values, fieldName, total) => {
  if (!Array.isArray(values) || values.length === 0) return [];

  let exactTotal = typeof total === "number" && !isNaN(total) ? total : 0;

  // Prepare values with their truncation and decimals preserved
  const items = values.map((v) => {
    const raw =
      typeof v[fieldName] === "number" && !isNaN(v[fieldName])
        ? v[fieldName]
        : 0;
    const trunc = Math.floor(raw);
    const decimal = raw - trunc;
    return { ...v, trunc, decimal };
  });

  // Calculate total after truncation
  const truncSum = items.reduce((sum, { trunc }) => sum + trunc, 0);
  let unitsLeft = Math.round(exactTotal - truncSum);

  // Allocate remaining units to those with largest decimals
  items
    .sort((a, b) => b.decimal - a.decimal)
    .forEach((item, i) => {
      if (i < unitsLeft) item.trunc += 1;
    });

  // Final mapping, set fieldName to the adjusted value
  return items.map(({ trunc, ...rest }) => ({
    ...rest,
    [fieldName]: trunc,
  }));
};
